import {
  HashRouter,
  Navigate,
  Route,
  Routes,
  redirect,
} from "react-router-dom";
import Add from "../pages/add";
import Generator from "../pages/campaigns/generators";
import Transformer from "../pages/campaigns/transformers";
import Downloads from "../pages/downloads";
// import Home from "../pages/home";
import Reports from "../pages/reports";
import ReportsOld from "../pages/reportsOld";
import PageNotFound from "../pages/notFound";
import PrivateRoute from "./PriveteRoute";
import { useContext, useEffect, useState } from "react";
import AuthContext from "./authContext";
import Calendars from "../pages/campaigns/calendars";
import Engines from "../pages/campaigns/engines";
import Products from "../pages/campaigns/products";
import Campaigns from "../pages/campaigns/campaigns";
import ApiPage from "../pages/api";
import ScheduleTime from "../pages/config";
import Dam from "../pages/dam";
import Project from "../pages/project";
import ChangePass from "../pages/changePass";
import ManagerUsers from "../pages/manager_users";
import EditUser from "../pages/manager_users";
import LoginPage from "../pages/login";
import BP2FAPage from "../pages/login/bp2fa";
import { useNavigate } from "react-router-dom";
import { useIdleTimer } from "react-idle-timer";

function Router() {
  const { auth, logout } = useContext(AuthContext);

  /**
   * Ends the session when user is idle by using frontend logout flow.
   */
  // Generated by GitHub Copilot
  const onIdle = () => {
    logout();
  }

  useIdleTimer({
    onIdle,
    timeout: 900_000,
    throttle: 500
  })

  return (
    <Routes>
      <Route path="/newweb/login" element={<LoginPage />} />
      <Route path="/newweb/login/bp2fa" element={ <BP2FAPage /> } />

      <Route path="/" element={<Navigate to="/newweb/login" />} />

      <Route path="/newweb/">
        <Route
          index
          element={
            <PrivateRoute auth={auth}>
              <Reports />
            </PrivateRoute>
          }
        />

        <Route
          path="/newweb/reports"
          element={
            <PrivateRoute auth={auth}>
              <Reports />
            </PrivateRoute>
          }
        />
        
        <Route
          path="/newweb/reports.old"
          element={
            <PrivateRoute auth={auth}>
              <ReportsOld />
            </PrivateRoute>
          }
        />

        <Route
          path="/newweb/downloads"
          element={
            <PrivateRoute auth={auth}>
              <Downloads />
            </PrivateRoute>
          }
        />
        <Route
          path="/newweb/add"
          element={
            <PrivateRoute access={auth.access.modSystem}>
              <Add />
            </PrivateRoute>
          }
        />

        <Route
          path="/newweb/calendars"
          element={
            <PrivateRoute access={auth.access.modCalendars}>
              <Calendars />
            </PrivateRoute>
          }
        />

        <Route
          path="/newweb/engines"
          element={
            <PrivateRoute access={auth.access.modEngines}>
              <Engines />
            </PrivateRoute>
          }
        />
        <Route
          path="/newweb/products"
          element={
            <PrivateRoute access={auth.access.modProducts}>
              <Products />
            </PrivateRoute>
          }
        />
        <Route
          path="/newweb/generators"
          element={
            <PrivateRoute access={auth.access.modGenerators}>
              <Generator />
            </PrivateRoute>
          }
        />
        <Route
          path="/newweb/transformers"
          element={
            <PrivateRoute access={auth.access.modConverters}>
              <Transformer />
            </PrivateRoute>
          }
        />
        <Route
          path="/newweb/campaigns"
          element={
            <PrivateRoute access={auth.access.modCampaigns}>
              <Campaigns />
            </PrivateRoute>
          }
        />

        <Route
          path="/newweb/api"
          element={
            <PrivateRoute access={auth.access.modCampaigns}>
              <ApiPage />
            </PrivateRoute>
          }
        />

        <Route
          path="/newweb/config"
          element={
            <PrivateRoute access={auth.access.modCampaigns}>
              <ScheduleTime />
            </PrivateRoute>
          }
        />

        <Route
          path="/newweb/dam"
          element={
            <PrivateRoute access={auth.access.modCampaigns}>
              <Dam />
            </PrivateRoute>
          }
        />

        <Route
          path="/newweb/project"
          element={
            <PrivateRoute access={auth.access.modCampaigns}>
              <Project />
            </PrivateRoute>
          }
        />

        <Route
          path="/newweb/mngr_users"
          element={
            <PrivateRoute access={auth.access.modCampaigns}>
              <ManagerUsers />
            </PrivateRoute>
          }
        />

        <Route
          path="/newweb/mngr_users/edit"
          element={
            <PrivateRoute access={auth.access.modCampaigns}>
              <EditUser />
            </PrivateRoute>
          }
        />

        <Route
          path="/newweb/changepass"
          element={
            <PrivateRoute access={auth.access.modCampaigns}>
              <ChangePass />
            </PrivateRoute>
          }
        />

        <Route path="/newweb/*" element={<PageNotFound />} />
      </Route>
    </Routes>
  );
}

export default Router;
